export const youtube = () => {
  return (
    <svg
      width="37"
      height="25"
      viewBox="0 0 37 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M36.2252 3.9225C36.0158 3.16552 35.6077 2.48019 35.0445 1.93936C34.4653 1.3819 33.7555 0.983132 32.982 0.780701C30.0872 0.00774329 18.4892 0.00774346 18.4892 0.00774346C13.6542 -0.0479835 8.8203 0.197117 4.01491 0.741663C3.24139 0.959048 2.5329 1.36672 1.95244 1.92843C1.3821 2.48433 0.968988 3.16984 0.753184 3.92094C0.23478 6.75003 -0.017096 9.62263 0.000951363 12.5C-0.0175461 15.3748 0.233712 18.2464 0.753184 21.079C0.964363 21.827 1.37593 22.5094 1.94781 23.0606C2.5197 23.6118 3.23185 24.01 4.01491 24.2208C6.94831 24.9922 18.4892 24.9922 18.4892 24.9922C23.3304 25.048 28.1704 24.8029 32.982 24.2583C33.7555 24.0559 34.4653 23.6571 35.0445 23.0997C35.6148 22.5484 36.0202 21.8629 36.2237 21.1165C36.7556 18.2885 37.0143 15.4147 36.996 12.5359C37.036 9.64489 36.7777 6.75756 36.2252 3.92094V3.9225ZM14.802 17.8467V7.15487L24.4516 12.5016L14.802 17.8467Z" />
    </svg>
  )
}
